// import { getAccountMe,getOrgMe,refreshToken } from '@/api/auth/index'
import { useCache } from '@/hooks/web/useCache'
import { useAppStore } from '@/store/modules/app'
import { useAuthStoreWithOut } from '@/store/modules/auth';
const appStore = useAppStore()
const authStore = useAuthStoreWithOut()
/**
 *
 * @returns any
 */
export const RefreshToken = async () => {
    // refreshToken().then((res : any)=>{
    //     if(res && res.code==0){
    //         // utils.setCookie('EIToken', res.data.accessToken)
    //         // utils.setCookie('EIName', utils.getCookie('EIName'))
    //     }
    // })
}

/**
 *
 * @returns any
 */
 export const GetUserInfo = async () => {
    let accountData:any = {username:''}
    if (window.$wujie && window.$wujie.props.userInfo) {
        accountData = window.$wujie.props.userInfo
    } else {
        // accountData.userName = sessionStorage.getItem('validUser')
        accountData.userName = 'zhang.tian@advantech.com.cn'
    }
    accountData.username = accountData.userName
    authStore.setUserInfo(accountData)
    // return new Promise(resolve => {      
    //     getAccountMe().then((me:any) => {
    //         console.log(me)
    //         if(me && me.code==0){
    //             if (!me.data.roles || me.data.roles.length===0) {
    //                 resolve('user has no roles')
    //             } else {
    //                 const { wsCache } = useCache()
    //                 wsCache.set(appStore.getUserInfo, {
    //                     ...me.data,
    //                     permissions:['*.*.*'],
    //                     password:''})
    //                 authStore.setUserInfo(me.data)
    //                 resolve(null)
    //             }
    //         } else resolve(me.msg)
    //     }).catch((err:any) => {
    //         console.log(err)
    //         resolve(err)
    //     })
    // })    
}

/**
 *
 * @returns any
 */
 export const GetTenantInfo = async () => {
    if (window.$wujie && window.$wujie.props.orgInfo) {
        authStore.setOrgInfo(window.$wujie.props.orgInfo)
    } else {
        authStore.setOrgInfo({id:1,name:'Main Org.',orgs:[]})
    }    
    // return new Promise((resolve) => {
    //     getOrgMe().then((res:any) => {
    //         if(res && res.code==0) authStore.setOrgInfo(res.data)
    //         else resolve(res.msg)
    //     }).finally(() => {
    //         resolve(null)
    //     })
    // })    
}

// auth

export const isAdmin = () => {
    return authStore.isOrgAdmin || authStore.isPartsSuperAdmin || authStore.isSuperAdmin
}
export const canRead = (routeName:any) => {
    return true
    if (isAdmin()) return true
    let moduleName = routeName
    // 隐藏路由需要做特殊处理
    // template/batch, template/partsin, parts/partsin, parts/partsdetail
    switch (routeName) {
        // 批量导入和模板出库的权限需要根据Template决定
        case 'WarehousingBatch':
        case 'TemplatePartsIn':
            moduleName = 'Template'
            break
        // 入库和备件详情的权限需要根据Template决定
        case 'PartsIn':
        case 'PartsDetail':
            moduleName = 'PartsList'
            break
    }
    const auth = authStore.getUsersAuthByModule(moduleName)
    if (auth && auth.read) return true
    return authStore.getUsersAuthByModule(moduleName).read
}
export const canWrite = (routeName:any) => {
    return true
    if (isAdmin()) return true
    let moduleName = routeName
    // 隐藏路由需要做特殊处理
    // template/batch, template/partsin, parts/partsin, parts/partsdetail
    switch (routeName) {
        // 批量导入和模板出库的权限需要根据Template决定
        case 'WarehousingBatch':
        case 'TemplatePartsIn':
            moduleName = 'Template'
            break
        // 入库和备件详情的权限需要根据Template决定
        case 'PartsIn':
        case 'PartsDetail':
            moduleName = 'PartsList'
            break
    }
    const auth = authStore.getUsersAuthByModule(moduleName)
    if (auth && auth.write) return true
    return authStore.getUsersAuthByModule(moduleName).write
}

export const ApplicantLabel = applicant => {
    if (!applicant) return ''
    if (applicant.full_name) return applicant.full_name
    if (applicant.user_name) return applicant.user_name
    return ''
}
// auth